import { render } from "./HomePageWelcome.vue?vue&type=template&id=4a0bdf04&scoped=true"
import script from "./HomePageWelcome.vue?vue&type=script&lang=js"
export * from "./HomePageWelcome.vue?vue&type=script&lang=js"

import "./HomePageWelcome.vue?vue&type=style&index=0&id=4a0bdf04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0bdf04"]])

export default __exports__